import { Empty } from 'antd';
import React from 'react';
import LoaderComponent from '../../../components/LoaderComponent';
import RackMasterCard from './RackMasterCard';

const RackMasterList = ({
  rackMasterList,
  loading,
  isEmptyRackMasterList,
  infiniteScrollRef,
  isFetchMoreOrderLoading,
}) => (
  <div>
    {' '}
    {!isEmptyRackMasterList &&
      rackMasterList?.map((order) => (
        <RackMasterCard
          key={order?.id}
          order={order}
          infiniteScrollRef={infiniteScrollRef}
        />
      ))}
    {(loading || isFetchMoreOrderLoading) && (
      <LoaderComponent size="small" setHeight={10} />
    )}
    {isEmptyRackMasterList && <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />}
  </div>
);

export default RackMasterList;
